module.exports = __webpack_public_path__ + "front/img/gift.27167e0d.png";